import { Box, CircularProgress, Typography } from "@mui/material";
import DetailsCard from "../../../../../customComponents/DetailsCard";
import { useLocation, useParams } from "react-router-dom";
import { useGetSharedNoteQuery } from "../../../../../app/notesApiSlice";
import NoteComments from "../../teacher/notes/NoteComments";
import NotePreviewContent from "../../teacher/notes/NotePreviewContent";

const ViewExpandedNote = () => {
  const location = useLocation();
  const { id } = useParams();
  const noteFromState = location.state?.note;
  const { data, isLoading } = useGetSharedNoteQuery(
    { share_id: id },
    { skip: !id }
  );
  const sharedNote = data?.note || noteFromState;
  const note = sharedNote?.note;

  if (isLoading && !sharedNote) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!note) {
    return (
      <Box>
        <Typography variant="h6">Note not found</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box>
        <DetailsCard
          header={note.topic}
          subHeading1={"Teacher Name"}
          value1={"Abdulalim Ladan"}
          subHeading2={"Subject"}
          value2={note.subject}
          subHeading3={"Level"}
          value3={note.level}
        />
        <Box
          sx={{
            padding: "3em",
            backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
            borderRadius: "12px",
          }}
        >
          <Typography variant="h4" sx={{ fontSize: "2em", fontWeight: 600 }}>
            {note.topic}
          </Typography>
          <Box sx={{ margin: "2em 0" }}>
            <NotePreviewContent note={note} />
          </Box>
        </Box>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Comments
          </Typography>
          <NoteComments
            sharedNote={sharedNote}
            emptyMessage="No comments have been submitted yet."
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ViewExpandedNote;
